import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import type { LD_CLAIM_DUPLICATE_STATUS } from '@/contants/ClaimsEnums';
import { axiosInstance } from '@/utils/fetcher';

export interface CheckDuplicateClaimRequestParams {
  claimKey: number;
  freightBillNo: number | string;
  invoiceNo: number | string;
}

export const checkDuplicateClaimAPI = (params: CheckDuplicateClaimRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/CheckDuplicateClaim`,
  });
};

export type CheckDuplicateClaimResponse = (typeof LD_CLAIM_DUPLICATE_STATUS)[keyof typeof LD_CLAIM_DUPLICATE_STATUS];

export const checkDuplicateClaim = async (
  params: CheckDuplicateClaimRequestParams,
): Promise<CheckDuplicateClaimResponse> => {
  const response: AxiosResponse<CheckDuplicateClaimResponse> = await checkDuplicateClaimAPI(params);
  return response.data;
};
